import styled from 'styled-components';

const ratio = 32 / 9;
const ratioToPaddingPercentage = (ratio1: number) => (1 / ratio1) * 100;

export const Aspect = styled.div`
  width: 100%;
  position: relative;
  padding-top: ${ratioToPaddingPercentage(ratio)}%;
  overflow: hidden;
`;

export const Image = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
